<template>
    <div
        :data-component-name="$options.name"
    >
        <q-field dense placehoder="Non assigné" icon="add">
            <div class="o-item-with-error">
                <q-icon class="o-item-with-error-icon" name="error" v-if="hasError && $attrs.value && hasError.user_profile_id==$attrs.value.id && hasError.type=='ASSIGNMENTCONFLICT'">
                    <q-tooltip>
                        Cet employé est assigné à plus d'un quart de travail pendant cette période
                    </q-tooltip>
                </q-icon>
                <q-icon class="o-item-with-error-icon" name="do_not_disturb_on_total_silence" v-if="hasError && $attrs.value && hasError.user_profile_id==$attrs.value.id && hasError.type=='ABSENCECONFLICT'">
                    <q-tooltip>
                        Cet employé est absent pendant au moins une journée pour cette période
                    </q-tooltip>
                </q-icon>
                <q-icon class="o-item-with-warning-icon" name="hourglass_bottom" v-if="hasDraft">
                    <q-tooltip>
                        Cette information n'est pas publiée
                    </q-tooltip>
                </q-icon>
            </div>
            <template v-slot:append>
                <q-icon name="arrow_drop_down"
                    v-if="!accessLevel.isLimited"
                />
            </template>
            <template v-slot:prepend>
                <q-icon name="delete_outline" color="" class="cursor-pointer"
                    @click.stop="$emit('remove-assignment')"
                    v-if="!accessLevel.isLimited || !$attrs.value"
                />
            </template>

            <template v-slot:control>
                <div v-if="$attrs.value" class="input-style row items-center">
                    {{ $attrs.value.name }}
                    <UserProfileInfo :currentDate="firstDate" :userProfile="$attrs.value" class="q-mr-xs q-ml-xs" @click.stop.prevent />
                    <q-icon
                        class="assignment-remove rotate-45 q-ml-xs"
                        name="add_circle"
                        size="16px"
                        @click.stop="$emit('unassign')"
                        v-if="!accessLevel.isLimited || !$attrs.value"
                    />
                </div>
                <div v-else class="input-style text-red">Non assigné</div>
            </template>
            <q-popup-proxy 
                content-class="bestcandidate-wrapper"
                ref="qAssignmentProxy"
                transition-show="scale"
                transition-hide="scale"
                @show="search(null)"
                v-if="!accessLevel.isLimited"
            >
                <div class="-header">
                    <q-input borderless dark type="text" placeholder="Rechercher" autofocus v-model="searchText" debounce="500">
                        <template v-slot:prepend>
                            <q-spinner
                                v-if="($apollo.queries.bestcandidate && $apollo.queries.bestcandidate.loading) || loading "
                            />
                            <q-icon name="search" v-else />
                        </template>
                    </q-input>
                </div>


                <div class="-content">
                    <div class="bestCandidate-row" :key="index" v-for="(bestCandidate, index) in bestCandidates"
                        @click="$refs.qAssignmentProxy.hide(); $emit('input', bestCandidate)"
                    >
                        <div>
                            <div class="bestCandidate-row-top">
                                <div class="right">
                                    <div>{{ bestCandidate.name }}<UserProfileInfo :currentDate="firstDate" :userProfile="bestCandidate" class="q-ml-sm" @click.stop.prevent /></div>
                                    <div>
                                        <small v-if="bestCandidate.profession" style="font-weight:800;" class="text-green">
                                            {{ bestCandidate.profession }}
                                            <small class="text-white" v-if="bestCandidate.otherProfessions.length>0"  style="font-weight:normal">
                                                    + {{ bestCandidate.otherProfessions.length }} métiers
                                                    <q-tooltip>
                                                        <div>{{ bestCandidate.profession }}</div>
                                                        <div v-html="bestCandidate.otherProfessions.map(e => e.name).join('<br>')"></div>
                                                    </q-tooltip>
                                            </small>
                                        </small>
                                        <small v-else-if="bestCandidate.otherProfessions.length>0" style="font-weight:800;">
                                            {{ bestCandidate.otherProfessions[0].name }}
                                            <small class="text-white" v-if="bestCandidate.otherProfessions.length>1" style="font-weight:normal">
                                                    + {{ bestCandidate.otherProfessions.length-1 }} métiers
                                                    <q-tooltip>
                                                        <div v-html="bestCandidate.otherProfessions.map(e => e.name).join('<br>')"></div>
                                                    </q-tooltip>
                                            </small>
                                        </small>
                                    </div>
                                    <div>
                                        <small
                                            v-bind:key="skill.id+'-'+index"
                                            v-for="(skill, index) in bestCandidate.skills"
                                        >
                                            <!-- <small
                                                size="sm"
                                                square
                                                :color="variables.tags.includes(skill.id) ? 'warning' : ''"
                                                :text-color="variables.tags.includes(skill.id) ? 'white' : ''"
                                            > -->
                                                {{ skill.name }}
                                            <!-- </small> -->
                                        </small>
                                        <small
                                            v-bind:key="course.id+'-'+index"
                                            v-for="(course, index) in bestCandidate.courses"
                                        >
                                            <!-- <small
                                                size="sm"
                                                square
                                                :color="variables.tags.includes(course.id) ? 'positive' : ''"
                                                :text-color="variables.tags.includes(course.id) ? 'white' : ''"
                                            > -->
                                                {{ course.name }}
                                            <!-- </small> -->
                                        </small>
                                    </div>
                                </div>
                                <div class="left">
                                    <q-rating
                                        :value="bestCandidate.rating/20"
                                        size="0.8rem"
                                        :max="5"
                                        color-selected="green"
                                        color="grey"
                                        icon-half="circle_half"
                                        icon="circle_border"
                                        icon-selected="circle"
                                        readonly
                                    />
                                    <div class="-meta">
                                        <small>
                                            <!-- <div>Rating : {{ bestCandidate.rating }}</div> -->
                                            <div title="Pertinence du résultat">
                                                {{ bestCandidate.relevancy.toFixed(2) }}
                                                <q-icon name="show_chart" />
                                            </div>
                                            <div v-if="bestCandidate.seniority!='n/d'" title="Ancienneté">
                                                {{ bestCandidate.seniority }}
                                                <q-icon name="elderly" />
                                            </div>
                                            <div>
                                                <span class="" v-if="bestCandidate.distance && bestCandidate.distance!=0" title="Distance du bureau">
                                                    {{ bestCandidate.distance }} km
                                                    <span v-if="bestCandidate.distance_orientation && bestCandidate.distance_orientation!=''">
                                                        , {{ bestCandidate.distance_orientation }}
                                                    </span>
                                                </span>
                                                <q-icon title="Véhicule disponible" v-if="bestCandidate.vehicule_available" name="directions_car" />
                                            </div>
                                        </small>
                                    </div>
                                    <div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="-footer">
                    <div class="buttons-wrapper">
                        <q-radio size="24px" v-model="availability" val="available" label="Dispo." @input="availability='available'" />
                        <q-radio size="24px" v-model="availability" val="unavailable" label="Non dispo." @input="availability='unavailable'" />
                        <q-radio size="24px" v-model="availability" val="all" label="Tous" @input="availability='all'" />
                        <div class="-splitter">
                        </div>
                        <q-checkbox dark v-model="sort_by_hiring_date" size="24px" label="trier par ancienneté" />
                    </div>
                </div>
            </q-popup-proxy>
        </q-field>
    </div>
</template>

<script>

import { BESTCANDIDATE } from '@/graphql/user/queries'
import moment from 'moment';

export default {
        name: 'BestCandidateDialogV2',
        //components: { Component1, Component2 },
        props: {
            variables: {
                type: Object,
                default() {
                    return {
                        professions: Number,
                        tags: Array
                    }
                }
            },
            hasError: {
                type: [Object],
                default() {
                    return null
                }
            },
            hasDraft: {
                type: Boolean,
                default: false,
            },
            accessLevel: {
                type: [Object],
                default() {
                    return null
                }
            }
        },
        data(){
        	return {
                searchText: null,
                bestCandidates: [],
                availability: 'available',
                loading: true,
                searchTO: {},
                firstDate: null,
                sort_by_hiring_date: false,
                restore_sort_by_hiring_date: null,
        	}
        },
        mounted(){
            if(this.variables.dates?.length>0){
                this.firstDate=this.variables.dates[0].from
            }

            if (this.$generalSettings.settings?.useHiringDateSort && this.$generalSettings.settings.useHiringDateSort == '1') {
                this.sort_by_hiring_date = true
            }
        },
        computed: {
            queryVariables(){
                // this.setLoading();
                return { ...this.variables, search: this.searchText, availability: this.availability, sortByHiringDate: this.sort_by_hiring_date} 
            },
        },
        watch: {
            searchText(val, oldval) {
                // if (val !== oldval) {
                //     this.search()
                // }
                if(val!='' && (!oldval || oldval=='')){
                    this.restore_sort_by_hiring_date = (this.sort_by_hiring_date) ? true : false
                    this.sort_by_hiring_date = false
                }
                if(val=='' && oldval!=''){
                    this.sort_by_hiring_date = (this.restore_sort_by_hiring_date) ? true : false
                }
            },
        },
        methods: {
            // setLoading(){
            //     this.loading=true
            // },
            search(){
                // this.loading=true
                // clearTimeout(this.searchTO)
                // this.searchTO=setTimeout(function(){
                //     if(this.$apollo && this.$apollo.queries && this.$apollo.queries.bestcandidate) this.loading=this.$apollo.queries.bestcandidate.loading
                // }.bind(this), 505)

                if(this.$apollo.queries.bestcandidate) return;

                this.$apollo.addSmartQuery('bestcandidate', {
                    query: BESTCANDIDATE,
                    fetchPolicy: 'no-cache',
                    // debounce: 500,
                    watchLoading(isLoading) {
                        this.loading = isLoading;
                    },
                    notifyOnNetworkStatusChange: true,
                    variables(){
                        return {...this.queryVariables}
                    },
                    update(data){
                        this.bestCandidates = [];
                        if (data.bestCandidates) {
                            data.bestCandidates.forEach(function (item) {
                                let otherProfessions = [];
                                item.professions.forEach(function (profession) {
                                    if (this.queryVariables.professions != profession.id) {
                                        otherProfessions.push({
                                            shortname: profession.shortname,
                                            name: profession.name
                                        })
                                    }
                                }.bind(this))

                                item.seniority = 'n/d';
                                if (item.hiring_date && item.hiring_date != '') {
                                    let m = moment(item.hiring_date, 'YYYY-MM-DD');
                                    // let years = moment().diff(m, 'years', false);
                                    let years = moment().diff(m, 'years', true);
                                    // let days = moment().diff(m.add(years, 'years'), 'days', false);
                                    let days = moment().diff(m, 'days', false);
                                    item.seniority = '';
                                    if (years != 0) item.seniority += years.toFixed(2) + ' an';
                                    if (years < 1) item.seniority = days + ' jour';
                                    if (years > 1 || years < -1 || (years < 1 && years > -1 && (days > 1 || days < -1))) item.seniority += 's';
                                    // if (years != 0 && days != 0) item.seniority += ', ';
                                    // if (days != 0) item.seniority += days + ' jour';
                                    // if (days > 1 || days < -1) item.seniority += 's';
                                }
                                this.bestCandidates.push({ ...item, otherProfessions })
                            }.bind(this))
                        }
                        return data
                        // this.loading=false
                    }
                })
            }
        },
    }
</script>

<style lang="scss">
    .assignment-remove {
        color: lightgrey;

        &:hover {
            color: darkgrey;
            cursor: pointer;
        }
    }

    body .bestcandidate-wrapper {
        background-color: $color-1-darkest; //toDo : variable pour le dark?
        min-width: 400px;
        width: 400px;
        min-height: 450px;
        max-height: 450px;
        display: flex;
        flex-direction: column;

        & .bestCandidate-row {
            line-height: 1.2rem;
            & > div {
                padding: 10px 30px;
                border-bottom: 1px solid $color-1;
            }

            &:hover{
                cursor: pointer;
                background-color: $color-1-darker; //toDo : variable pour le dark?
            }

            &-top{
                display: flex;
                flex-direction: row;
                
                & .right {
                    flex-grow: 1;

                    small {
                        margin-right: 8px;
                    }
                }

                & .left {
                    text-align: right;
                    div {
                        white-space: nowrap;
                        flex-flow: row;
                    }

                    .-meta {
                        opacity: 0.5
                    }
                }
            }
        }

        & .-content {
            flex-grow: 1;
            padding: 0px 0;
            padding-bottom: 10px;
            overflow: hidden;
            overflow-y: auto;
            color: white;
        }
        & .-header, & .-footer {
            background-color: $color-1-dark; //toDo : variable pour le dark?
            padding: 0 30px;
        }
        & .-header {
            border-bottom: 1px solid $color-1-darkest;
        }
        & .-footer {
            border-top: 1px solid $color-1-darkest;
            padding: 10px 20px;
            color: white;
            & .buttons-wrapper{
                display: flex;
                flex-direction: row;
                justify-content: space-evenly;
                font-size: 0.85rem;

                .-splitter {
                    border-left: 1px solid $color-1;
                    width: 1px;
                    max-width: 1px
                }
            }
        }

        & .q-radio__inner--falsy {
            color: white;
        }
    }
</style>
